import React from 'react';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';

const AtlasSales1P3PSplineChart = () => {
  return (
    <AtlasV2DorisSplineChart
      queryKey="RetailSaleProductCountSplineChart"
      title="Product Count"
      showLastWeekValue={true}
      methodName="sales/GetSalesMetrics"
      metricTypeDisplay={METRICTYPE.VOLUME}
      metricType="ProductsWithSalesCount"
    />
  );
};

export default AtlasSales1P3PSplineChart;
